import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
    RouteRecordRaw,
} from "vue-router";
import {useUserStore} from "@/store/user";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/ProductEn/Index/:tk",
        name: "Index",
        component: () => import("@/views/index/index.vue"),
        meta: {title: "首页", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        path: "/ProductEn/KdIndex/:tk",
        name: "KdIndex",
        component: () => import("@/views/index/KdIndex.vue"),
        meta: {title: "宽带广场", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        path: "/ProductEn/Shop/:tk",
        name: "ShopPoster",
        component: () => import("@/views/index/ShopPoster.vue"),
        meta: {title: "店铺海报", wechatBrowserGuide: true, wechatSliderGate: false}
    },
    {
        path: "/h5orderEn/index",
        name: "GoodsDetails",
        component: () => import("@/views/goods/GoodsDetails.vue"),
        meta: {title: "商品详情", wechatBrowserGuide: true, wechatSliderGate: true}
    },
    {
        path: "/Pay/WxToBrowser",
        name: "WxPayMiddle",
        component: () => import("@/views/pay/WxPayMiddle.vue"),
        meta: {title: "支付", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/Pay/AlipayReturn_url/:status",
        name: "AlipayReturnUrl",
        component: () => import("@/views/pay/AlipayReturnUrl.vue"),
        meta: {title: "支付结果", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/PackInfo/Detail/:pro_id",
        name: "PackageDetails",
        component: () => import("@/views/goods/PackageDetails.vue"),
        meta: {title: "套餐详情", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/Search/Index",
        name: "OrderQuery",
        component: () => import("@/views/order/OrderQuery.vue"),
        meta: {title: "订单查询", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/Search/GOrder",
        name: "OrderList",
        component: () => import("@/views/order/OrderList.vue"),
        meta: {title: "订单列表", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/Search/Ord",
        name: "OrderDetails",
        component: () => import("@/views/order/OrderDetails.vue"),
        meta: {title: "订单详情", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/Search/Express",
        name: "OrderWuliu",
        component: () => import("@/views/order/OrderWuliu.vue"),
        meta: {title: "物流信息", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/Search/CourierExpress",
        name: "CourierOrderWuliu",
        component: () => import("@/views/order/CourierOrderWuliu.vue"),
        meta: {title: "物流信息", wechatBrowserGuide: false, wechatSliderGate: true}
    },
    {
        path: "/PicEdit/PicInfo",
        name: "OrderPicEdit",
        component: () => import("@/views/order/OrderPicEdit.vue"),
        meta: {title: "证件信息上传", wechatBrowserGuide: false, wechatSliderGate: false}
    },
    {
        path: "/PicEdit/Index",
        name: "OrderPicEditWarning",
        component: () => import("@/views/order/OrderPicEditWarning.vue"),
        meta: {title: "证件信息上传", wechatBrowserGuide: false, wechatSliderGate: false}
    }
];

// history: createWebHistory(process.env.BASE_URL),
const router = createRouter({
    history: createWebHistory(),
    routes,
});

export const isSetUserTk = ["Index","KdIndex", "ShopPoster","GoodsDetails"];


router.beforeEach((to, from, next) => {
    const {setUserInfo} = useUserStore();
    // 构建新的 hash 值
    if (isSetUserTk.includes(to.name as string)) {
        if (setUserInfo(to)) {
            next();
        }
    } else {
        next();
    }
});

router.afterEach((to) => {
    document.title = (to.meta?.title as string) || "首页";
});


export default router;
